import React from "react";
import AOS from 'aos';
import 'aos/dist/aos.css'; 
import { useEffect } from "react";


function About() {
  useEffect(() => {
    AOS.init({
      once: true,
    });
  }, []);
  return (
    <section id="about" className="pb-32 pt-32"> 
      <div className="container">
        <h1 className="mb-4 pl-4 font-mukta text-2xl font-bold text-primary md:text-4xl">
          About
        </h1>
        <div className="flex flex-wrap">
          <div className="mb-5 w-full px-4 md:w-1/2" data-aos="fade-right" data-aos-duration="1000" data-aos-delay="200" data-aos-offset="100"
  data-aos-anchor-placement="top-bottom">
            <h2 className="mb-2 text-lg font-semibold text-slate-800">
              Skills
            </h2>
            <p className="text-sm font-medium text-slate-500 md:text-base">
              Junior Front-End Web Developer skilled in HTML, CSS, TailwindCss,
              JavaScript, React, and building responsive websites integrated
              with platforms like Shopify, WordPress, and Woocommerce.
            </p>
          </div>
          <div className="mb-2 w-full px-4 md:w-1/2" data-aos="fade-left" data-aos-duration="1000" data-aos-delay="200" data-aos-offset="100"
  data-aos-anchor-placement="top-bottom">
            <h2 className="mb-2 text-lg font-semibold text-slate-800">
              Experience
            </h2>
            <p className="text-sm font-medium text-slate-500 md:text-base">
              Built websites for clients in various industries as a Junior
              Front-End Web Developer. Continuously learning and enthusiastic
              about creating attractive, effective websites. Contact for
              assistance.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
